export function toNative(p) {
    return new Promise(function (resolve, reject) {
        if (p && typeof p.then === 'function') {
            // forward fulfillment value as T
            p.then(function (v) { return resolve(v); }, reject);
        }
        else {
            resolve(p);
        }
    });
}
export var toNativeVoid = function (p) {
    return Promise.resolve(p);
};
